import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  createUrlTreeFromSnapshot,
  Params,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { PermissionService } from '@campus/shared';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PermissionGuard implements CanActivate {
  private unAuthorizedUrl = '/v2/error/401';
  private getAllRouteData(route: ActivatedRouteSnapshot): {
    params: Record<string, string>;
    queryParams: Record<string, string>;
    permissions: string[];
    fallbackUrl?: string | ((params: Params) => string);
  } {
    let result = {
      params: { ...route.params },
      queryParams: { ...route.queryParams },
      fallbackUrl: route.data?.fallbackUrl,
      permissions: route.data?.fallBackPermissions,
    };

    if (route.firstChild) {
      const childData = this.getAllRouteData(route.firstChild);
      result = {
        params: { ...result.params, ...childData.params },
        queryParams: { ...result.queryParams, ...childData.queryParams },
        fallbackUrl: childData.fallbackUrl || result.fallbackUrl,
        permissions: childData.permissions || result.permissions,
      };
    }

    return result;
  }
  constructor(private permissionService: PermissionService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const { requiredPermissions } = route.data;
    const { permissions, fallbackUrl, params, queryParams } = this.getAllRouteData(route);

    if (!requiredPermissions?.length && !permissions?.length) return true;
    //getAlRouteData, take the most relevant permissions and fallbackUrl

    return combineLatest([
      this.permissionService.hasPermission$(permissions || []),
      this.permissionService.hasPermission$(requiredPermissions || []),
    ]).pipe(
      map(([noRedirect, permitted]) => {
        if (!noRedirect) {
          let url = fallbackUrl;
          if (typeof url === 'function') {
            //with params
            url = url(params);
          }
          Object.entries(params).forEach(([key, value]) => {
            url = (url as string).replace(`:${key}`, value);
          });

          const urlTree = createUrlTreeFromSnapshot(route, [url], queryParams);
          return urlTree;
        }
        if (!permitted) return this.router.parseUrl(this.unAuthorizedUrl);
        return true;
      })
    );
  }
}
